// extracted by mini-css-extract-plugin
export default {"componentWrapper":"LoginButton_componentWrapper__O2qtF","authButton":"LoginButton_authButton__ngKWo"};